<template>
  <div class="ticketCheck">
    <div class="ocr border" @click="ocrClick">
      <img src="@/assets/img/ticket/OCRIcon.png" alt="">
      快捷认证
    </div>
    <div class="center">
      <div class="carTitle">车牌号码</div>
      <car-number :inputValue="inputValue" @submit="carSubmit"></car-number>
    </div>
    <div class="center">
      <van-field
        readonly
        name="picker"
        :value="formData.numberPlateType"
        label="号牌类型"
        placeholder="请选择"
        label-class="fieldLabel"
        class="field fieldInput"
        @click="showPicker = true"
      >
      <template #right-icon>
        <van-icon name="arrow" />
      </template>
      </van-field>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
    </div>
    <van-form>
      <div class="center">
        <van-field
            v-model="formData.vinNo"
            label="车架号码"
            placeholder="请输入"
            label-class="fieldLabel"
            class="field fieldInput"
            :rules="rules.vinNo"
            @input="inputChange('vinNo')"
          />
      </div>
      <div class="center">
        <van-field
            v-model="formData.engineNo"
            label="发动机号"
            placeholder="请输入"
            label-class="fieldLabel"
            class="field fieldInput"
            :rules="rules.engineNo"
            @input="inputChange('engineNo')"
          />
      </div>
    </van-form>
    <div class="btn">
      <van-button type="info" size="large" :disabled="disabled" @click="goParkingViolationsCheck">{{carInfo ? '修改车辆信息' : '保存车辆'}}</van-button>
      <div class="delete" v-if="carInfo" @click="deleteConfirm">删除车辆</div>
    </div>
    <div class="thirdParty">由第三方服务商提供</div>
    <ocr :showOcr="showOcr" @afterRead="afterRead" @cancel="cancelOcr"></ocr>
    <van-overlay :show="loading" class="ocr-loading">
      <van-loading type="spinner" color="#c9c9c9" vertical>
        <span style="color: #c9c9c9">正在识别...</span>
      </van-loading>
    </van-overlay>
  </div>
</template>
<script>
import CarNumber from '../../components/car-number.vue';
import { saveCar, deleteCar, getCarOcr, carList} from "@/common/api.js";
import { cloneDeep } from "lodash";
import { upload } from "@/utils/oss.js";
import ocr  from './components/ocr.vue'
import UploadHelper from "@/common/upload-helper.js";
export default {
  name: "carCheck",
  components: {
    CarNumber,
    ocr
  },
  data() {
    return {
      formData: {
        numberPlateType: '小型汽车'
      },
      showPicker: false,
      columns: ['小型汽车', '大型汽车'],
      inputValue: [],
      carNo: [],
      numberPlateType: '小型汽车',
      rules: {
        vinNo: [
          { required: true, message: '车架号码不能为空' },
          { pattern: /^(?!\d+)[A-HJ-NPR-Z\d]{8}[X\d][A-HJ-NPR-Z\d]{3}\d{5}$/, message: '请输入正确的车架号码' }
        ],
        engineNo: [
          { required: true, message: '发动机号不能为空' },
          { pattern: /^[A-Za-z\d]{5,25}$/, message: '请输入正确的发动机号' }
        ]
      },
      carInfo: null,
      showOcr: false,
      loading: false
    }
  },
  watch: {
    inputValue(val) {
      this.carNo = val
    },
    showPicker(val) {
      if(!val){
        this.numberPlateType = this.formData.numberPlateType
      }
    },
    '$route.query.carInfo': {
      immediate: true,
			handler() {
          if(this.$route.query.carInfo){
            this.carInfo = this.$route.query.carInfo ? JSON.parse(this.$route.query.carInfo) : null;
            this.formData = this.carInfo;
            this.carNo = this.carInfo.carNo;
            this.numberPlateType = this.carInfo.numberPlateType === '02' ? '大型汽车' : '小型汽车';
            this.formData.numberPlateType = this.carInfo.numberPlateType === '02' ? '大型汽车' : '小型汽车'
            this.inputValue = this.carInfo.carNo ? this.carInfo.carNo.split('') : [];
          }
          
			},
    }
  },
  computed: {
    disabled(){
      return !(this.carNo && this.carNo.length == 7 && this.numberPlateType && this.formData.vinNo && this.formData.engineNo)
    }
  },
  mounted() {
  },
  methods: {
    onConfirm(value) {
      this.formData.numberPlateType = value;
      this.showPicker = false;
    },
    inputChange(val) {
      if(val == 'vinNo'){
        // this.formData.vinNo = this.formData.vinNo.replace(/^(?!\d+)[A-HJ-NPR-Z\d]{8}[X\d][A-HJ-NPR-Z\d]{3}\d{5}$/);s
      }
    },
    carSubmit(val) {
      this.formData.carNo = val
    },
    async addCar() {
      this.formData.phone = this.$route.query.phone;
      let data = cloneDeep(this.formData)
      data.numberPlateType = this.formData.numberPlateType === "大型汽车" ? '02' : '01'
      const res = await saveCar(data)
      if(this.carInfo) {
        this.$router.go(-1)
      }else{
        this.$router.push({
          path: '/parkingViolationsCheck',
          query: {
            phone: this.$route.query.phone,
            categoryCode: this.$route.query.categoryCode,
            productCode: this.$route.query.productCode,
          },
        });
      }
    },
    deleteConfirm() {
      this.$dialog.confirm({
        title: '删除确认',
        message:
          '确认删除该车辆吗？',
      })
        .then(() => {
          // on confirm
          this.deleteCarClick()
        })
        .catch(() => {
          // on cancel
        });
    },
    async deleteCarClick() {
      const res = await deleteCar(this.formData)
      this.getCarList()
    },
    async getCarList() {
      const res = await carList({phone: this.$route.query.phone})
      if(res.length <= 0){
        this.$router.replace({
          path: '/carCheck',
          query: {
            phone: this.$route.query.phone,
            categoryCode: this.$route.query.categoryCode,
            productCode: this.$route.query.productCode,
          },
        });
      }else{
        this.$router.go(-1)
      }
    },
    goParkingViolationsCheck() {
      this.addCar()
    },
    async afterRead(data) {
      this.loading = true
      try{
        const res = await UploadHelper(data.file);
        if (!res.picId) {
          this.$toast("图片上传失败");
          return;
        }
        const rs = await getCarOcr({fileId:res.picId})
        if(rs && rs.carNo) {
          this.formData = rs
          this.formData.numberPlateType = rs.numberPlateType === '02' ? '大型汽车' : '小型汽车'
          this.numberPlateType = rs.numberPlateType
          this.carNo = rs.carNo
          this.inputValue = rs.carNo ? rs.carNo.split('') : []
        }
      }catch (error) {
        console.log(error, 'err');
      }
      this.showOcr = false
      this.loading = false
    },
    ocrClick() {
      this.showOcr = true
    },
    cancelOcr() {
      this.showOcr = false
    }
  }
}
</script>
<style scoped lang="scss">
.ticketCheck{
  width: 100%;
  background: #F4F6F7;
  font-family:'Microsoft YaHei';
  .border{
    border-top: 0.3rem solid #F4F6F7;
  }
  .ocr{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: #3399FF;
    font-size: 0.32rem;
    background: #fff;
    padding: 0.3rem 0.4rem;
    box-sizing: border-box;
    img{
      width: 0.35rem;
      margin-right: 0.2rem;
    }
  }
  .center{
    border-bottom: 1px solid #e6e6e6;
    padding: 0 0.4rem 0.3rem;
    background: #fff;
    .numberInfo{
      font-size: 0.26rem;
      color: #787878;
      height: 0.8rem;
      line-height: 0.8rem;
    }
    .img{
      display: flex;
      justify-content: space-between;
      img{
        width: 43vw;
      }
    }
    .carTitle{
      font-size: 0.36rem;
      color: #383838;
      font-weight: 900;
      padding: 0.1rem 0 0.3rem;
      &::after{
        content: '*';
        color: #EA3F26;
        font-size: 0.3rem;
        font-weight: 100;
      }
    }
  }
  .fieldTitle{
    font-size: 0.3rem;
    color: #787878;
    height: 0.9rem;
    line-height: 0.9rem;
  }
  .field{
    padding: 0;
  }
  .fieldInput{
    padding-top: 0.3rem;
  }
  /deep/ .fieldLabel{
    font-size: 0.3rem;
    color: #787878;
    ::after{
      content: '*';
      color: #EA3F26;
    }
  }
  .check{
    font-size: 0.2rem;
    color: #787878;
    padding: 0.8rem 0 0.3rem;
    display: flex;
    justify-content: center;
    background: #fff;
  }
  .btn{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 1rem 0.4rem 0.4rem;
    background: #fff;
    /deep/ .van-button{
      border-radius: 0.2rem;
    }
    .delete{
      width: 100vw;
      text-align: center;
      color: #597CA0;
      font-size: 0.32rem;
      margin: 0.3rem 0;
    }
  }
  /deep/ .van-cell::after{
    border-bottom: 1px solid #fff;
  }
  .thirdParty{
    font-size: 0.24rem;
    color: #C8C8C8;
    text-align: center;
    background: #fff;
    line-height: 0.8rem;
  }
  .ocr-loading {
    .van-loading {
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

</style>